import React, { useEffect, useState, useCallback } from "react";
import { ScrollText, RefreshCw, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { fmtFecha } from "@/lib/format";

const Auditoria = () => {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(true);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/auditoria");
      setRegistros(data.registros || []);
    } catch (e) { /* noop */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { document.title = "Auditoría · AXIORA"; cargar(); }, [cargar]);

  return (
    <div className="p-6">
      <header className="flex items-center justify-between mb-5">
        <div>
          <h2 className="font-serif-ax text-4xl text-[#F5F5F7] tracking-wide">Auditoría</h2>
          <p className="text-xs text-[#71717A] mt-0.5">Bitácora de seguridad y operaciones</p>
        </div>
        <button data-testid="auditoria-refresh" onClick={cargar}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#0A0A0A] border border-[#1F1F24] text-[#A1A1AA] hover:text-[#D4AF37] text-sm">
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} /> Actualizar
        </button>
      </header>

      <div className="rounded-xl bg-[#0A0A0A] border border-[#1F1F24] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[#050505]">
              <tr className="text-[10px] uppercase tracking-wider text-[#71717A]">
                <th className="text-left px-4 py-3">Fecha y hora</th>
                <th className="text-left px-4 py-3">Usuario / IP</th>
                <th className="text-left px-4 py-3">Acción</th>
                <th className="text-left px-4 py-3">Módulo</th>
                <th className="text-left px-4 py-3">Estado</th>
              </tr>
            </thead>
            <tbody>
              {registros.length ? registros.map((r, i) => (
                <tr key={r.id || i} data-testid={`auditoria-row-${i}`} className="border-t border-[#1F1F24] hover:bg-white/[0.02]">
                  <td className="px-4 py-3 font-mono-ax text-xs text-[#A1A1AA] whitespace-nowrap">{fmtFecha(r.fecha)}</td>
                  <td className="px-4 py-3 text-xs">
                    <div className="text-[#F5F5F7]">{r.actor || "—"}</div>
                    <div className="font-mono-ax text-[#52525b]">{r.ip}</div>
                  </td>
                  <td className="px-4 py-3 text-[#F5F5F7] text-xs">{r.evento}</td>
                  <td className="px-4 py-3">
                    <span className="text-[10px] uppercase tracking-wider text-[#D4AF37]/80 border border-[#D4AF37]/20 rounded-full px-2 py-0.5">{r.modulo}</span>
                  </td>
                  <td className="px-4 py-3">
                    {r.ok ? (
                      <span className="flex items-center gap-1 text-[#4ECDC4] text-xs"><CheckCircle2 className="w-3.5 h-3.5" /> OK</span>
                    ) : (
                      <span className="flex items-center gap-1 text-[#FF6B5B] text-xs"><XCircle className="w-3.5 h-3.5" /> Fallo</span>
                    )}
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={5} className="px-4 py-12 text-center text-[#52525b] text-sm">
                  <ScrollText className="w-8 h-8 mx-auto mb-2 opacity-40" />
                  Sin registros de auditoría todavía.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Auditoria;
